import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { pricingPlans, companyStats } from '../mock';

const PricingCard = ({ plan, onGetStarted }) => (
  <div
    className={`relative rounded-2xl p-6 border transition-all ${
      plan.popular
        ? 'bg-gradient-to-b from-[#1a0f2e] to-[#0f0817] border-[#a855f7]/50 shadow-[0_20px_50px_-10px_rgba(124,58,237,0.4)]'
        : 'bg-[#0d0d16]/70 border-white/5 hover:border-white/10'
    }`}
  >
    {plan.popular && (
      <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full text-[10.5px] font-semibold bg-gradient-to-r from-[#a855f7] to-[#4f46e5] text-white shadow-[0_0_15px_rgba(124,58,237,0.5)]">
        Most Popular
      </div>
    )}
    <div className="text-white font-semibold text-[16px]">{plan.name}</div>
    <div className="text-gray-400 text-[11.5px] mt-0.5">{plan.subtitle}</div>
    <ul className="mt-5 space-y-2.5">
      {plan.features.map((f) => (
        <li key={f} className="flex items-center gap-2 text-[12.5px] text-gray-300">
          <Check className="w-3.5 h-3.5 text-[#a855f7]" strokeWidth={3} />
          {f}
        </li>
      ))}
    </ul>
    <Button
      onClick={onGetStarted}
      className={`w-full mt-5 h-10 rounded-md text-[13px] font-semibold border-0 ${
        plan.popular
          ? 'bg-gradient-to-r from-[#7c3aed] to-[#4f46e5] hover:from-[#8b45f0] hover:to-[#5b52ee] text-white shadow-[0_0_20px_rgba(124,58,237,0.35)]'
          : 'bg-white/5 border border-white/10 text-white hover:bg-white/10'
      }`}
    >
      {plan.cta}
    </Button>
  </div>
);

const PricingSection = ({ onGetStarted }) => {
  return (
    <section id="pricing" className="relative py-20">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-white text-[32px] lg:text-[36px] font-bold tracking-tight">
            Simple Pricing. Maximum Value.
          </h2>
        </div>

        <div className="grid lg:grid-cols-[repeat(3,minmax(0,300px))_1fr] gap-5 items-stretch justify-center">
          {pricingPlans.map((p) => (
            <PricingCard key={p.name} plan={p} onGetStarted={onGetStarted} />
          ))}

          {/* Stats card */}
          <div className="rounded-2xl bg-[#0d0d16]/60 border border-white/5 p-6 relative overflow-hidden min-h-[380px] min-w-[260px]">
            <div className="grid grid-cols-2 gap-x-4 gap-y-5 relative z-10">
              {companyStats.map((s) => (
                <div key={s.label}>
                  <div className="text-white text-[26px] font-bold tracking-tight bg-gradient-to-r from-[#c084fc] to-[#a855f7] bg-clip-text text-transparent">
                    {s.value}
                  </div>
                  <div className="text-gray-400 text-[11.5px] mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            {/* Dotted world map */}
            <div className="absolute inset-x-6 bottom-4 opacity-40">
              <svg viewBox="0 0 300 100" className="w-full">
                {Array.from({ length: 180 }).map((_, i) => {
                  const x = (i % 30) * 10 + 5;
                  const y = Math.floor(i / 30) * 15 + 8;
                  const active = Math.random() > 0.55;
                  return active ? (
                    <circle key={i} cx={x} cy={y} r="1" fill="#a855f7" opacity={Math.random() * 0.8 + 0.2} />
                  ) : null;
                })}
              </svg>
            </div>

            <div className="absolute bottom-4 left-6 right-6 text-[11.5px] text-gray-400 z-10 max-w-[220px]">
              Trusted by founders, agencies, and businesses around the world.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
